import SEO from '../../seo/SEO'
import { generateOrganizationSchema } from '../../seo/structuredData'
import './Nosotros.css'

const Nosotros = () => {
  const structuredData = generateOrganizationSchema()

  return (
    <>
      <SEO 
        title="Sobre Nosotros"
        description="Conoce a Vanesa Mondejar, contadora pública del Estudio Contable Vanesa Mondejar con más de 10 años de experiencia en servicios contables profesionales. Estudio contable especializado en soluciones integrales para empresas."
        canonical="https://vanesamondejar.com/nosotros"
        structuredData={structuredData}
        keywords="vanesa mondejar, estudio contable vanesa mondejar, contadora publica, sobre nosotros, estudio contable, servicios contables profesionales"
      />
      
      <main className="nosotros">
        <section className="nosotros-hero">
          <div className="container">
            <div className="nosotros-hero__content">
              <h1 className="nosotros-hero__title">Sobre Nosotros</h1>
              <p className="nosotros-hero__subtitle">
                Más de 10 años brindando servicios contables profesionales con dedicación y excelencia
              </p>
            </div>
          </div>
        </section>

        <section className="nosotros-content">
          <div className="container">
            <div className="nosotros-content__grid">
              <div className="nosotros-content__text">
                <h2 className="nosotros-content__title">Nuestra Historia</h2>
                <p className="nosotros-content__paragraph">
                  El Estudio Contable Vanesa Mondejar nació con la visión de brindar servicios contables 
                  de excelencia, combinando la experiencia profesional con un trato personalizado y cercano.
                </p>
                <p className="nosotros-content__paragraph">
                  Con más de 10 años de trayectoria, hemos acompañado a numerosas empresas y profesionales 
                  en su crecimiento, adaptándonos a las necesidades específicas de cada cliente y 
                  manteniéndonos siempre actualizados con las últimas normativas contables e impositivas.
                </p>
                <p className="nosotros-content__paragraph">
                  Nuestro compromiso es brindar soluciones integrales que permitan a nuestros clientes 
                  enfocarse en su negocio principal, mientras nosotros nos encargamos de toda la gestión 
                  contable y fiscal.
                </p>
              </div>
              
              <div className="nosotros-content__image">
                <img 
                  src="/nosotros-image.jpg" 
                  alt="Vanesa Mondejar - Contadora Pública" 
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="nosotros-estudio">
          <div className="container">
            <div className="nosotros-estudio__content">
              <h2 className="nosotros-estudio__title">El Estudio</h2>
              <p className="nosotros-estudio__subtitle">
                Un espacio profesional diseñado para brindar asesoramiento contable en un entorno de confianza y confidencialidad.
              </p>
              <div className="nosotros-estudio__image-wrapper">
                <img 
                  src="/imagenEstudio.jpeg" 
                  alt="Estudio Contable Vanesa Mondejar - Oficina profesional" 
                  loading="lazy"
                  className="nosotros-estudio__image"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="nosotros-values">
          <div className="container">
            <h2 className="nosotros-values__title">Nuestros Valores</h2>
            <div className="nosotros-values__grid">
              <div className="nosotros-values__card">
                <div className="nosotros-values__card-icon">🎯</div>
                <h3 className="nosotros-values__card-title">Excelencia</h3>
                <p className="nosotros-values__card-description">
                  Nos comprometemos a brindar servicios de la más alta calidad, 
                  manteniendo estándares profesionales excepcionales.
                </p>
              </div>
              
              <div className="nosotros-values__card">
                <div className="nosotros-values__card-icon">🤝</div>
                <h3 className="nosotros-values__card-title">Confianza</h3>
                <p className="nosotros-values__card-description">
                  Construimos relaciones duraderas basadas en la transparencia, 
                  honestidad y confidencialidad absoluta.
                </p>
              </div>
              
              <div className="nosotros-values__card">
                <div className="nosotros-values__card-icon">📚</div>
                <h3 className="nosotros-values__card-title">Actualización</h3>
                <p className="nosotros-values__card-description">
                  Nos mantenemos constantemente actualizados con las últimas 
                  normativas y tecnologías del sector contable.
                </p>
              </div>
              
              <div className="nosotros-values__card">
                <div className="nosotros-values__card-icon">⚡</div>
                <h3 className="nosotros-values__card-title">Eficiencia</h3>
                <p className="nosotros-values__card-description">
                  Optimizamos procesos para brindar soluciones rápidas y efectivas, 
                  respetando siempre los plazos establecidos.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="nosotros-team">
          <div className="container">
            <h2 className="nosotros-team__title">Nuestro Equipo</h2>
            <div className="nosotros-team__content">
              <div className="nosotros-team__member">
                <div className="nosotros-team__member-image">
                  <img 
                    src="/vanesa-mondejar.jpg" 
                    alt="Vanesa Mondejar - Contadora Pública" 
                    loading="lazy"
                  />
                </div>
                <div className="nosotros-team__member-info">
                  <h3 className="nosotros-team__member-name">Vanesa Mondejar</h3>
                  <p className="nosotros-team__member-title">Contadora Pública - C.P.C.E.CABA Tomo 430 Folio 126</p>
                  <p className="nosotros-team__member-description">
                    Contadora Pública con más de 10 años de experiencia brindando soluciones contables integrales. 
                    Especializada en contabilidad general, asesoramiento impositivo, liquidación de sueldos, 
                    consultoría empresarial, auditorías, constitución de empresas e higiene y seguridad laboral. 
                    Matrícula profesional: C.P.C.E.CABA Tomo 430 Folio 126
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="nosotros-cta">
          <div className="container">
            <div className="nosotros-cta__content">
              <h2 className="nosotros-cta__title">¿Listo para trabajar con nosotros?</h2>
              <p className="nosotros-cta__subtitle">
                Contactanos hoy mismo y descubrí cómo podemos ayudarte a optimizar la gestión contable de tu empresa.
              </p>
              <div className="nosotros-cta__actions">
                <a 
                  href="/contacto" 
                  className="nosotros-cta__button nosotros-cta__button--primary"
                >
                  Contactar
                </a>
                <a 
                  href="https://wa.me/5491166201346" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="nosotros-cta__button nosotros-cta__button--whatsapp"
                >
                  📱 WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default Nosotros
